<template>
  <span class="view-select" :id="field.key">
    <!-- Si es array, mostrar todas las opciones -->
    <span v-if="field.isArray && Array.isArray(displayValue)">
      <span
        v-for="(val, index) in displayValue"
        :key="index"
        class="select-item"
      >
        {{ getOptionLabel(val) }}
        <span v-if="index < displayValue.length - 1">, </span>
      </span>
    </span>
    <!-- Valor simple -->
    <span v-else>
      {{ getOptionLabel(displayValue) }}
    </span>
  </span>
</template>

<script>
export default {
  name: "ViewFieldSelect",
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: [String, Number, Boolean, Array],
      default: null,
    },
    item: {
      type: Object,
      default: null,
    },
    modelName: {
      type: String,
      default: "",
    },
    isGroupModel: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    displayValue() {
      if (this.value !== null && this.value !== undefined && this.value !== "") {
        return this.value;
      }
      if (this.field.defaultValue !== undefined && this.field.defaultValue !== null) {
        return this.field.defaultValue;
      }
      return null;
    },
  },
  methods: {
    getOptionLabel(value) {
      if (!this.field.options || !Array.isArray(this.field.options)) {
        return value || "";
      }
      const option = this.field.options.find((opt) => opt.value === value);
      if (option) {
        return this.$t(option.label) || option.label || String(value);
      }
      return value || "";
    },
  },
};
</script>

<style scoped>
.view-select {
  font-weight: 500;
}

.select-item {
  display: inline;
}
</style>

